/*!
 * doTERRA CRM
 * http://www.doterra.com
 *
 * Copyright 2019 doTERRA Holdings, LLC
 * All Rights Reserved
 */
import React, {useState} from "react";
import {useJson} from '../../shared/utils/json';
import {WindowProvider} from "../../shared/contexts/window";
import {PageProvider} from "../../shared/contexts/page";
import {PaymentsProvider, usePaymentsMutator, usePaymentsState} from "../../shared/contexts/payments";
import {CustomerProvider} from "../../shared/contexts/customer";
import {PaymentView} from '../../shared/containers/payment-view';
import {FormObserver, useFormObserverState} from '../../shared/contexts/form-observer';
import {PrimaryButton} from '../../shared/components/controls';
import {text} from '../../shared/utils/i18n';
import {createRoot} from "react-dom/client";
import {getAndStripAttribute} from "../../shared/utils/dom-container-util";

const EnrollmentPayments =(props) => {
    const [disableContinueBtn, setDisableContinueBtn] = useState(false);
    const { model, markets } = props;
    const cardMessage = model.creditCardMessage;
    const runEnv = model.digitalWalletRunEnvironment;

    const { isValid, paymentformSubmit } = useFormObserverState();
    const { addPayment } = usePaymentsMutator();
    const { payments } = usePaymentsState(); //Resolve pop up models twice time.




    const handleContinueClick = () => {
        const ZERO = 0;
        if (paymentformSubmit) {
            if(gv_strToken && gv_strToken.trim().length > ZERO) {
            swapToken();
            }
            paymentformSubmit();
        } else {
            addPayment({});
        }
        window.validateGTMFunction('addPaymentMethodClick_gtm');
    };

    const handleFormSubmission = payment => {
        addPayment(payment);
    };

    const canContinue = (isValid || payments.length > 0);

    const disableContinue = (bool) => {
      queueMicrotask(() => {
        setDisableContinueBtn(bool);
      });
    };

	if(canContinue && !disableContinueBtn) {
        $('#submit-order').removeClass('disabled');
    } else {
        $('#submit-order').addClass('disabled');
    }
    $('#submit-order').off('click').on('click',handleContinueClick);

    return (
        <>
            <div className="col-xs-12">
                <PaymentView initialMode={ payments.length > 0 ? 'list' : 'select' }
                             citMitMessage={cardMessage}
                             digitalWalletEnv={runEnv}
                             googlePayMerchantId={model.googlePayMerchantId}
                             recaptchaKey={model.recaptchaKey}
                             markets={markets}
                             onSubmit={handleFormSubmission}
                             disableContinue={disableContinue}
                             cartShippingAddress={model.cartShippingAddress}/>
            </div>
            <div className="col-xs-12 text-center">
                <PrimaryButton role="button" tabindex="0" id='enrollment-pay-submit' onClick={handleContinueClick} disabled={!canContinue || disableContinueBtn } text={text('text.order.review')}/>
            </div>
        </>
    );
};

const EnrollmentPaymentsContainer = (props) => {
    const { parseJson } = useJson();
    const model = parseJson(props.model);
    const markets = props.markets;
    const customerId = model.customerId || model.uid;
    const activePaymentMethods = model.activePaymentMethods || 'card';

    return (
        <WindowProvider>
            <PageProvider>
                <CustomerProvider uid={model.uid} customerId={customerId} language={model.language}>
                    <PaymentsProvider context='enrollment' activePaymentMethods={activePaymentMethods} address={model.billingAddress} ccNonce={model.ccNonce}>
                        <FormObserver>
                            <EnrollmentPayments markets={markets} model={model}/>
                        </FormObserver>
                    </PaymentsProvider>
                </CustomerProvider>
            </PageProvider>
        </WindowProvider>
    );
};

const domContainer = document.querySelector('#enrollment-payments-container');
if (domContainer) {
  const markets = getAndStripAttribute('data-markets', domContainer);
  const model = getAndStripAttribute('data-model', domContainer);
  const root = createRoot(domContainer);
  root.render(<EnrollmentPaymentsContainer markets={markets} model={model}/>);
}
